import { Col, Row } from "antd";
import React, { useEffect } from "react";
import MenuItemLayout from "../menuItemLayout/MenuItemLayout";
import banner from "../../../assets/images/intern_banner.png";
import heroMobile from "../../../assets/images/intern-mob.png";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import Loader from "../../../biblio/Loader/Loader";
import { getAllvisions } from "../../../apis/actions/visionMession.actions";

const VisionsPage = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { visions, loading } = useSelector(
    (state: RootState) => state?.visions
  );
  useEffect(() => {
    dispatch(getAllvisions());
  }, [dispatch]);

  if (loading) {
    return <Loader />;
  }

  console.log(visions);
  return (
    <MenuItemLayout
      mobileImage={heroMobile}
      title="من نحن"
      subTitle="الرؤية - الرسالة"
      urlImage={banner}
      className="takaful--our-branches"
    >
      <Row
        dir="rtl"
        gutter={[24, 24]}
        justify={"center"}
        style={{ minHeight: "300px", padding: "2rem 0" }}
      >
        <Col xxl={1} xl={1} lg={1} md={0} sm={0} xs={0}></Col>
        <Col
          xxl={10}
          xl={10}
          lg={10}
          md={20}
          sm={20}
          xs={20}
          className="takaful--vision-mission-col"
        >
          <div className="takaful--vision-mission-card">
            <h3 className="takaful--vision-mission-title">الرؤية</h3>
            <p className="takaful--vision-mission-text">
              الأنموذج المؤسسي الريادي في رعاية وتنمية الأيتام
            </p>
          </div>
        </Col>
        <Col
          xxl={10}
          xl={10}
          lg={10}
          md={20}
          sm={20}
          xs={20}
          className="takaful--vision-mission-col"
        >
          <div className="takaful--vision-mission-card">
            <h3 className="takaful--vision-mission-title">الرسالة</h3>
            <p className="takaful--vision-mission-text">
              رعاية وتنمية الأيتام بالشراكة الفاعلة مع الداعمين باحترافية من
              العاملين بالجمعية
            </p>
          </div>
        </Col>
        <Col xxl={1} xl={1} lg={1} md={0} sm={0} xs={0}></Col>
      </Row>
    </MenuItemLayout>
  );
};

export default VisionsPage;